// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"f523c4dc","598":"adbd6a8f"}[chunkId] + ".chunk.js";
};